export default __webpack_public_path__ + "static/media/back_to_community_logo.cae0e8dd.svg";